import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useHiringInformationConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            name: t("effective-date"),
            key: "date",
        },
        {
            name: t("job-group"),
            key: "jobGroup",
        },
        {
            name: t("hiring-date"),
            key: "hiringDate",
        },
        {
            name: t("employee-type"),
            key: "employeeType",
        },
        {
            name: t("user-groups"),
            key: "userGroups",
        },
        {
            name: t("union"),
            key: "union",
        },
        {
            name: t("project"),
            key: "project",
        },
        {
            name: t("pay-group"),
            key: "payGroup",
        },
    ], [t]);
}
